import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const annMariaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Anna Maria Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Anna Maria, FL. Sam\'s Tree Service handles dangerous trees on Anna Maria Island safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_anna_maria',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Anna Maria',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Anna Maria Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring expert tree care to the island 
     properties of <strong>Anna Maria</strong>. The combination of sandy soil, salt laden 
     air, and Gulf storms creates challenging conditions for trees roots weaken, trunks 
     lean, and canopies become dangerously overgrown. When those trees start threatening 
     your home, dock, or neighboring property, our crew steps in with the right tools and 
     experience to handle it safely.`,

    `We specialize in <strong>dangerous tree removal and precision trimming</strong> on 
     island properties including trees with compromised root systems, storm battered 
     palms, overhanging limbs near structures, and dense canopy growth creating serious 
     wind load risk during hurricane season. Every job is handled with care for your 
     property and your neighbors.`,

    `<strong>Sam's Tree Service</strong> provides dependable, affordable tree care 
     throughout <strong>Anna Maria</strong> and across <strong>Anna Maria Island</strong> 
     so your property stays protected and beautiful all year long.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Anna Maria, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_AnnaMaria = () => <LocationPage config={annMariaConfig} />;
export default Services_AnnaMaria;
